<template src="./VehicleType.html"></template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("vehicleType");
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { orderBy } from "@progress/kendo-data-query";
import DialogBox from "@/components/DialogBox";
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
export default {
  components: {
    DialogBox,
  },
  data: function() {
    return {
      gridHeight: window.innerHeight - 160,
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
         pageSizes: [5, 10, 25, 100,500],
        previousNext: true,
      },
      sort: [{ field: "name", dir: "asc" }],
      columns: [
        // { field: "vehicleTypeTenantMapID", title: "ID" },
        { field: "name", title: "Vehicle Type",  width: "250px"  },
        { field: "noofwheels", title: "No of wheels",  width: "200px"  },
        { field: "type", title: "Vehicle Icon",  width: "200px"  },
        { cell: CommandCell, title: "Actions",  width: "150px" },
      ],
    };
  },
  methods: {
    goToAddPage: function() {
      console.log('Adding vehicle type: ',);
      this.$router.push({ name: "VehicleTypeAdd", params: { add: true } });
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    edit(e) {
      console.log('update vehicle type: ', e);
      this.$router.push({ name: "VehicleTypeAdd", params: e.dataItem });
    },
    remove(item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
     vehicleTypeColumn(){
       return this.columns;
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("vehicleType/removeVehicleType", item.dataItem.id)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
          // this.getDataOnload();
        })
        .catch(notifyApiError);
    },
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters(["getVehicleTypes"]),
    total() {
      return this.getVehicleTypes.length
        ? this.getVehicleTypes.length
        : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.getVehicleTypes.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
  },
};
</script>
